<script lang="ts">
import listPanel from '@nuxtDatakodeUtils/components/i3p/panels/list-panel.vue'
import FiltersTemplate from '../common/list/FiltersTemplate.vue'
import Pagination from '../common/list/Pagination.vue'
import BasicFiltersOverride from '../common/list/BasicFiltersOverride.vue'
import { OpportunityService } from '~/services/opportunity.service'
import { Opportunity } from '~/models/Opportunity'
import OpportunityLikeActions from '~/components/I3pComponent/opportunities/entity/OpportunityLikeActions.vue'
// import OpportunityData = PildomModules.Voirie.Data.OpportunityData
import OpportunityData = PildomModules.Voirie.Data.OpportunityData
import OrganizationData = App.Data.Organization.OrganizationData
import GeojsonUrl from '~/components/I3pComponent/common/list/GeojsonUrl.vue'

export default {
    name: 'OpportunityListPanel',
    components: { GeojsonUrl, OpportunityLikeActions, FiltersTemplate, Pagination, BasicFiltersOverride },
    extends: listPanel,
    data() {
        return {
            columns: [
                { dataKey: 'id' },
                { dataKey: 'likes', transform: [this.organizationLikes] },
                { dataKey: 'commune.t' },
                { dataKey: 'my_like.value', transform: [this.myLike] },
                { dataKey: 'credentials.created_at', transform: [this.isDateTime] },
                { dataKey: 'credentials.updated_at', transform: [this.isDateTime] },
            ],

        }
    },
    computed: {
        myOrganization(): OrganizationData {
            return (this.$currentUser() as UserData).organization
        },
    },
    methods: {
        organizationLikes(key, value, object): string {
            const opportunityData = object as OpportunityData
            const opportunityService = new OpportunityService(new Opportunity(opportunityData))

            return opportunityData.organizations
                .map((organization) => {
                    return opportunityService.getOrganizationLikeChip(organization)

                    // return `${organization.name} ${JSON.stringify(like?.value ?? 'none')}`
                }).join(' ')
            // return JSON.stringify({ object })
        },
        myLike(key, value, object): string {
            if (!object.my_like) {
                return ''
            }
            const likeValue = object.my_like.value
            const stringValue = likeValue?.toString() || 'none'
            return this.isChips('like', stringValue, this.toTranslate('like', stringValue))
        },

    },

}
</script>

<template>
    <FiltersTemplate
        v-if="list?.meta"
        :meta="list?.meta"
        :translation-name="list?.model?.translationKey"
        :filters="filters"
        @set-query="setQuery($event)"
        @reset-query="i3pService.resetQuery()"
    >
        <template #moreButtons>
            <GeojsonUrl v-if="list?.model" intentions-or-opportunities="opportunities" />
            <ListActionsButtonsExport
                v-if="list?.model"
                :query="i3pService._query"
                :btn-style="{ variant: 'outlined', class: `ma-2` }"
                :request-name="list?.model?.endPoint"
                :translation-name="list?.model?.translationKey"
                :exportable="i3pService?.indexData?.meta.available_exports || []"
                show-disabled
            />
        </template>
        <template #filters>
            <BasicFiltersOverride
                ref="filters"
                :filters="filters"
                :translation-name="list?.model?.translationKey"
                @reset-pagination="i3pService.setPagination(1)"
                @load-data="i3pService.loadData()"
            />
        </template>
    </FiltersTemplate>

    <list-table
        ref="table"
        class="px-2 my-2"
        :highlight-row="[i3pService.currentEntityK]"
        :loading="loadingList"
        :value-as-view-link="['id']"
        :disable-view="true"
        :permission-name="list?.model?.permissionName || ''"
        :translation-name="list?.model?.translationKey || ''"
        :sortable="list?.meta?.allowed_sorts || []"
        :default-url="baseUrl"
        :data="list?.data || []"
        :columns
        no-action
        :show-global-loader="true"
        @default-redirect-clicked="showEntity($event.k)"
        @update-sort="i3pService.setSort($event)"
        @load-data="i3pService.loadData()"
        @reset-pagination="i3pService.setPagination({ number: 1, size: list?.meta?.per_page })"
    >
        <template #customColumn="{ item }">
            <OpportunityLikeActions :opportunity-data="item" :organization-data="myOrganization" />
        </template>
    </list-table>
    <Pagination
        v-if="list?.meta"
        :list
        @load-data="i3pService.loadData()"
    />
</template>
